import { createFileRoute, useParams } from "@tanstack/react-router";
import { QuoteDetailPage } from "@/components/inventory/QuoteDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/quotes_/$id")({
  component: AdminQuoteDetail,
});

function AdminQuoteDetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/quotes_/$id" });
  return <QuoteDetailPage quoteId={id} />;
}
